module.exports = __webpack_public_path__ + "img/82.de89db6e.jpg";